import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UrlConstantsService {

  environment = environment
  baseUrl = this.environment.baseUrl

  public HEALTH_STATUS = `${this.baseUrl}/api/v1/health-status`;

  public CHECK_NEW_EMAIL = `${this.environment.baseUrl}/api/v1/public/check-new-email`;

  public USER_LOGIN_EMAIL = `${this.baseUrl}/api/v1/auth/login`;
  public USER_REGISTER_EMAIL = `${this.baseUrl}/api/v1/auth/register`;
  public USER_REFRESH_TOKENS = `${this.baseUrl}/api/v1/auth/token-refresh`;
  public USER_FORGET_PASSWORD = `${this.baseUrl}/api/v1/auth/forgot-password`;
  public USER_RESET_PASSWORD = `${this.baseUrl}/api/v1/auth/reset-password`;

  public OWN_ORGANIZATION = `${this.baseUrl}/api/v1/organizations/mine`;
  public OWN_ORGANIZATION_AUTOBUY_FILTER = `${this.baseUrl}/api/v1/organizations/mine/autobuy-filter`;
  public OWN_ORGANIZATION_NOTIFICATION_SETTINGS = `${this.baseUrl}/api/v1/organizations/mine/notification-settings`;
  public OWN_ORGANIZATION_BONUS = `${this.baseUrl}/api/v1/organizations/mine/bonus`;
  public CLAIM_BONUS_REWARD = (key: string) => `${this.baseUrl}/api/v1/organizations/mine/bonus/rewards/${key}/claim`;
  public ORDER_BONUS_SEAL = `${this.baseUrl}/api/v1/organizations/mine/bonus/seal-order`;

  public GET_DEPOSIT_LINK = `${this.baseUrl}/api/v1/payment/deposit`;
  public DEPOSIT_OFFER = `${this.baseUrl}/api/v1/payment/deposit-offer`;

  public INQUIRY_BY_UUID = (uuid: string) => `${this.baseUrl}/api/v1/inquiries/${uuid}`;
  public PUBLIC_INQUIRIES = `${this.baseUrl}/api/v1/public/inquiries`;

  public MY_RATINGS = `${this.baseUrl}/api/v1/ratings`;

  public USERS = `${this.baseUrl}/api/v1/users/`;
  public OWN_USER = `${this.baseUrl}/api/v1/users/me`;

  public INQUIRY_PREVIEWS = `${this.baseUrl}/api/v1/inquiry/previews`;
  public HIDE_INQUIRY_PREVIEWS = (uuid: string) => `${this.baseUrl}/api/v1/inquiry/previews/${uuid}/hide`;
  public INQUIRY_BIDS = `${this.baseUrl}/api/v1/inquiry/bought`;
  public INQUIRY_BIDS_BY_UUID = (uuid: string) => `${this.baseUrl}/api/v1/inquiry/bought/${uuid}`;
  public BUY_INQUIRY = (uuid: string) => `${this.baseUrl}/api/v1/inquiry/previews/${uuid}/buy`;
  public REPORT_BOUGHT_INQUIRY = (uuid: string) => `${this.baseUrl}/api/v1/inquiry/bought/${uuid}/report`;
}
